module.exports = __webpack_public_path__ + "static/media/ἔρχομαι_img.11ff3a2b.JPG";